import ytVideo from "./components/ytVideo";
import cocSlider from "./components/cocSlider";
import targetSlider from "./components/targetSlider";
import timelineSlider from "./components/timeline";
import heroSlider from "./components/heroSlider";
import heroSliderRestyle2024 from "./components/heroSliderRestyle2024";
import header from "./components/header";
import megamenu from "./components/megamenu";
import search from "./components/search";
import countries from "./components/countries";
import upcomingEventsSlider from "./components/upcomingEventsSlider";
import imageLinksCarousel from "./components/imageLinks";
import highlightsCarousel from "./components/highlightsCarousel";
import gridSlider from "./components/gridSlider";
import fullWidthSlider from "./components/fullWidthSlider";
import itemsCarousel from "./components/itemsCarousel";
import domainSlider from "./components/domainSlider";
import languageChooser from "./components/languageChooser";
import linksBoxSlider from "./components/linksBoxSlider";
import latestNewsSlider from "./components/latestNewsSlider";
import latestNewsMediaSlider from "./components/latestNewsSliderMediaPage";
import selectInit from "./components/initSelect";
import countrySelect2 from "./components/countriesChooser";
import optionsSelect2 from "./components/optionsChooser";
import analytics from "./components/analytics";
import initGmap from "./components/gmap";
import resize from "./components/resize";
import smoothScroll from "./components/smoothScroll";
import newsProductSlider from "./components/newsProductSlider";
import customerQuotesSlider from "./components/customerQuotesSlider";
import informationProductSlider from "./components/informationProductSlider";
import filterCategory from "./components/filterCategory";
import filterOurSolution from "./components/filterOurSolution";
import formPopup from "./components/formPopup";
import sliderContent from "./components/sliderContent";
import accordion from "./components/accordion";

const appInit = () => {
    header.init();
    languageChooser.init();
    megamenu.init();
    search.init();
    selectInit.init();
    countries.init();
    heroSlider.init();
    heroSliderRestyle2024.init();
    cocSlider.init();
    targetSlider.init();
    timelineSlider.init();
    upcomingEventsSlider.init();
    ytVideo.init();
    highlightsCarousel.init();
    imageLinksCarousel.init();
    gridSlider.init();
    fullWidthSlider.init();
    itemsCarousel.init();
    domainSlider.init();
    linksBoxSlider.init();
    latestNewsSlider.init();
    latestNewsMediaSlider.init();
    countrySelect2.init();
    optionsSelect2.init();
    analytics.init();
    initGmap.init();
    resize.init();
    smoothScroll.init();
    newsProductSlider.init();
    customerQuotesSlider.init();
    informationProductSlider.init();
    filterCategory.init();
    filterOurSolution.init();
    formPopup.init();
    sliderContent.init();
    accordion.init();

}

appInit();
